import { cidsService } from '@/services/cids';
import { queryOptions } from '@tanstack/react-query';

export function normalizeCidCodes(codes: readonly string[]): string[] {
  return [
    ...new Set(
      codes
        .map(code => code.trim().toUpperCase())
        .filter(code => code && code !== '—')
    ),
  ];
}

export function cidDescriptionOptions(code: string) {
  const normalized = code.trim().toUpperCase();
  return queryOptions({
    // Separado do autocomplete, que pode retornar um resultado aproximado.
    queryKey: ['services', 'cids', 'exact-description', normalized],
    queryFn: async (): Promise<string | null> => {
      const response = await cidsService.search({
        q: normalized,
        page: 1,
        pageSize: 100,
      });
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao consultar descrição do CID');
      }
      const match = response.data.items.find(
        item => item.code.trim().toUpperCase() === normalized
      );
      return match?.description.trim() || null;
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  });
}

export function formatCidDescription(
  code: string,
  description: string | null | undefined
): string {
  if (description === undefined) return code;
  return code + ' — ' + (description || 'Descrição indisponível');
}
